import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { BuildingLibraryIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect, useState } from "react";
import { EyeIcon } from "@heroicons/react/20/solid";
import { ChangeBank } from "./ChangeBank";
import { OfertaViewContext } from "../../../../context/OfertaContext/OfertaViewContext";

export function ViewBankAccount() {
  const { updateMyBanks, myBanks } = useContext(OfertaViewContext);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [parentAccount, setParentAccount] = useState({});

  useEffect(() => {
    if (myBanks?.myBankAccounts) {
      let accounts = myBanks?.myBankAccounts;
      if (accounts && accounts.length > 0) {
        let parentAccount = accounts.filter(account => account.parent === true);
        setParentAccount(parentAccount[0]);
        updateMyBanks({...myBanks, parentAccount: parentAccount[0]});
      }
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, [myBanks?.myBankAccounts]);

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <div className="cursor-pointer min-w-full">
          <div className="flex text-purple underline">
            {" "}
            <EyeIcon className="w-4 h-auto" /> Ver cuenta bancaria{" "}
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed md:inset-y-0 bottom-0 md:right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform h-128 md:h-full transition duration-300 ease-in-out data-[closed]:translate-y-full"
              >
                <div className="flex h-full flex-col rounded-t-3xl md:rounded-none bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6">
                      <div className="flex justify-between px-4 pt-2 md:pt-8">
                        <DialogTitle>
                          <div className="text-white">
                            Confirma tu cuenta bancaria
                          </div>
                        </DialogTitle>
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className="pt-2 px-4 text-sm text-grayP">
                        Para que el desembolso sea exitoso la cuenta bancaria
                        debe estar a tu nombre, y los datos deben ser correctos,
                        de lo contrario, no podremos hacer el desembolso y
                        podemos anular el crédito que te hemos aprobado
                      </div>
                    </div>
                  </div>
                  <div className="h-full p-4 rounded-t-3xl bg-purpleLight overflow-auto">

                    {
                      parentAccount && (
                        <div className="bg-white rounded-3xl p-4">
                          <div className="w-full flex justify-between">
                            <h2 className="font-bold">Cuenta bancaria</h2>
                            <ChangeBank
                              />
                          </div>
                          <div className="flex gap-2 py-4 items-center">
                            <div className="w-10 h-10 rounded-full bg-purple grid content-center justify-items-center">
                              <BuildingLibraryIcon className="w-8 h-auto text-white" />
                            </div>

                            <div className="text-sm">
                              <div>{parentAccount?.bankAccount}</div>
                              <div>{parentAccount?.typeBankAccount}</div>
                              <div>{parentAccount?.accountNumber}</div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
